import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import UserMenu from '@/components/auth/UserMenu';
import ProjectSwitcher from './ProjectSwitcher';
import RouteErrorBoundary from './RouteErrorBoundary';
import AnalysisWatchdog from '@/components/system/AnalysisWatchdog';
import DemoSeeder from '@/components/system/DemoSeeder';
import HelpWidget from '@/components/support/HelpWidget';

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-pelip-bg text-pelip-text-soft">
      <AnalysisWatchdog />
      <DemoSeeder />
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main
        className="min-h-screen transition-all duration-200"
        style={{ marginLeft: collapsed ? 64 : 240 }}
      >
        {/* Cabecera persistente: proyecto actual (izq) + menú usuario (der).
            Así siempre se sabe en qué proyecto estás. */}
        <header className="sticky top-0 z-40 flex items-center justify-between gap-4 px-8 h-12 border-b border-pelip-border bg-pelip-bg/85 backdrop-blur-sm print:hidden">
          <ProjectSwitcher />
          <UserMenu />
        </header>
        <div className="max-w-[1400px] mx-auto px-8 py-6">
          <RouteErrorBoundary key={location.pathname}>
            <Outlet />
          </RouteErrorBoundary>
        </div>
      </main>
      <HelpWidget collapsed={collapsed} />
    </div>
  );
}
